import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ModelTranslation\UpsertModelTranslationController::__invoke
* @see app/Http/Controllers/Admin/ModelTranslation/UpsertModelTranslationController.php:13
* @route '/api/admin/model-translations'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/admin/model-translations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ModelTranslation\UpsertModelTranslationController::__invoke
* @see app/Http/Controllers/Admin/ModelTranslation/UpsertModelTranslationController.php:13
* @route '/api/admin/model-translations'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ModelTranslation\UpsertModelTranslationController::__invoke
* @see app/Http/Controllers/Admin/ModelTranslation/UpsertModelTranslationController.php:13
* @route '/api/admin/model-translations'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

const modelTranslations = {
    store: Object.assign(store, store),
}

export default modelTranslations